export enum UserSettingField {
    HiddenModelNames = 'hidden_model_names',
    ShownModelNames = 'shown_model_names',
    AggregateWaitTime = 't_aggregate_wait_s',
}
